module.exports = __webpack_public_path__ + "static/img/top2-img.6d0b549.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/top2-img.png
// module id = umGu
// module chunks = 1